import React, {useState, useEffect, useContext} from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import {useSelector, useDispatch} from 'react-redux';
import {labels, currentResource} from '../../../util/utils';
import OutputText from '@ey/canvascoreservices/OutputText';
import Input from '../../CoreWrappers/Input';
import Button from '../../CoreWrappers/Button';
import CustomTable from '../../CoreWrappers/CustomTable';
import LoadingWrapper from '../../CoreWrappers/LoadingWrapper';
import * as projectActionTypes from '../CreateProjectClassic/Helper/projectActionTypes';
import env from '../../../util/env';
import utilityfunctions from '../../../util/utilityfunctions';
import {serviceURL, projectStatusEnum, createProjectStepsIndex, UserLookupType} from '../../../util/uiconstants';
import {IconoirPlusCircle, IconoirWarningCircle, IconoirTrash} from '@ey-xd/motif-icon';
import _, {parseInt} from 'lodash';
import {ProjectContext} from './Helper/context';
import {clientEngagementsSelector} from './Helper/dataSelector';
import MotifChip from '@ey/motif-react-wrapper/Chip';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import Tooltip from '../../Common/Tooltip/Tooltip';
import Search from '../../Common/Search/MotifSearch';
import {rowSelectionType} from '@ey/canvascoreservices/Table';
import selectAllClients from '../../../reducers/Clients/selectors/selectAllClients';
import {clearAllProjects} from '../../../actions/Project/projectAction';
import {getAllClients} from '../../../actions/Clients/clientsaction';
import {
	clearProject,
	draftProject,
	createRollForwardProject,
	createProject,
	updateProject
} from '../../../actions/Project/projectcreationactions';
import AddProjectOwner from './Common/AddProjectOwner';
import AddElementButton from './AddNewGroup/AddElementButton';
import {clearClientEngagements} from '../../../actions/Engagement/engagementactions';
import {actionIcDelete24px} from '@ey/motif-react-wrapper/assets/icons';
import TextLink from '../../CoreWrappers/TextLink';
import StyledOutputTextWithLink from './Common/StyledOutputTextWithLink';

const CreateProjectStep1 = (props) => {
	//local variables
	const winWidth = window.innerWidth;

	//History
	const history = useHistory();

	//Context
	const {state, dispatch} = useContext(ProjectContext);

	//Dispatch
	const globalDispatch = useDispatch();

	//Reducers

	//Selectors
	const isEditMode = useSelector((state) => state.isEditMode.activated);
	const isRollForwardMode = useSelector((state) => state.isRollForwardMode);
	const userPreferences = useSelector((store) => store.userPreferences);
	const clients = useSelector(selectAllClients);
	const project = useSelector((store) => store.newProject);
	// we can pass props and some filterdata to useSelector hook if we want to filter data based on some condition
	const {clientEngagements} = clientEngagementsSelector(props);

	//States
	const [projectName, setProjectName] = useState('');
	const [selectedClients, setSelectedClients] = useState([]);
	const [showProjectNameValidation, setShowProjectNameValidation] = useState(false);
	const [showProjectOwnerValidation, setShowProjectOwnerValidation] = useState(false);
	const [showClientError, setshowClientError] = useState(false);
	const [rowData, setRowData] = useState([]);
	const {clientsLoading, setClientsLoading} = props;
	const [isSaving, setIsSaving] = useState(false);
	const userIdPrefix = 'user_';
	const [userList, setUserList] = useState([{id: `${userIdPrefix}${0}`, isNewAdd: true}]);
	const [users, setUsers] = useState([]);
	const [searchValue, setSearchValue] = useState('');
	const [customSelectedClients, setCustomSelectedClients] = useState([]);
	const [clientSearchData, setClientSearchData] = useState([]);

	//Effects
	useEffect(() => {
		var existingOwners = [];
		if (state.owners && state.owners.length > 0) {
			existingOwners = [...state.owners];
		} else {
			if (isEditMode || isRollForwardMode) {
				existingOwners = project.users
					.filter((x) => x.connectedGroups?.filter((y) => y.groupName == 'Project owners').length > 0)
					.sort(function(a, b) {
						return a.emailAddress.localeCompare(b.emailAddress);
					});

				if (isRollForwardMode && !existingOwners.some((o) => o.userId == userPreferences.gui)) {
					existingOwners.push({
						emailAddress: userPreferences.emailAddress,
						email: userPreferences.emailAddress,
						value: userPreferences.emailAddress,
						id: userPreferences.gui,
						isEmpty: false,
						isInternal: true,
						firstName: userPreferences.firstName,
						lastName: userPreferences.lastName,
						roles: [], // to do
						userId: userPreferences.gui
					});
				}
			} else {
				existingOwners.push({
					emailAddress: userPreferences.emailAddress,
					email: userPreferences.emailAddress,
					value: userPreferences.emailAddress,
					id: userPreferences.gui,
					isEmpty: false,
					isInternal: true,
					firstName: userPreferences.firstName,
					lastName: userPreferences.lastName,
					roles: [], // to do
					userId: userPreferences.gui
				});
			}
		}

		let userArray = [];
		let localUserCounter = 0;
		const usersContextArray = [];
		existingOwners.forEach((user) => {
			userArray.push({
				id: `${userIdPrefix}${localUserCounter}`,
				isEmpty: false,
				isLoggedInUser: user.emailAddress == userPreferences.emailAddress
			});
			usersContextArray.push({
				id: `${userIdPrefix}${localUserCounter}`,
				email: user.emailAddress,
				emailAddress: user.emailAddress,
				userId: user.userId,
				firstName: user.firstName,
				lastName: user.lastName,
				isInternal: true,
				isEmpty: false,
				roles: user.roles
			});
			localUserCounter = ++localUserCounter;
		});
		setUsers(usersContextArray);
		setUserList(userArray);
	}, [project.users, isEditMode]);

	// In edit mode we are reading project name and clients and in rollforward only project name is read from project
	useEffect(() => {
		if (isEditMode || isRollForwardMode) {
			setProjectName(project.name);
			if (clients?.length > 0) {
				const selectedData = project?.clients;
				setCustomSelectedClients(selectedData.map((x) => x.clientCode));
				dispatch({
					type: projectActionTypes.UPDATE_STEP1_DATA,
					payload: {name: projectName, clients: selectedData, status: project.status}
				});
			}
		}
	}, [clients]);

	// save as draft in edit flow - Editing a draft project.
	useEffect(() => {
		if (isEditMode && props.isSavingDraft && isValidData()) {
			let drafturl = `${env.getBaseURL(serviceURL)}Projects/${project.id}`;
			const selectedData = rowData.filter((x) => _.includes(customSelectedClients, x.clientCode));
			const savedProject = {
				Id: project.id,
				name: projectName,
				status: projectStatusEnum.DRAFT,
				clients: [...selectedData],
				owners: [...users],
				orgStructure: props.nodes.map((node) => {
					return {
						id: node.id.toString(),
						entityId: node.entityId || project.orgStructure?.find((x) => x.id == node.id)?.entityId,
						parentId: node.pid?.toString(),
						entityName: node.entityName,
						accessGroups: [...node.accessGroups],
						engagements: [...node.engagements]
					};
				})
			};

			props.setIsSaving(true);
			globalDispatch(draftProject(drafturl, savedProject))
				.then(() => {
					props.setIsSaving(false);
					props.setIsSavingDraft(false);
					globalDispatch(clearProject());
					globalDispatch(clearAllProjects());
					history.goBack();
				})
				.catch((e) => {
					props.setIsSaving(false);
					props.setIsSavingDraft(false);
				});
		} else {
			props.setIsSavingDraft(false);
		}
	}, [props.isSavingDraft]);

	// If user has navigated back from previous steps, update existing data
	useEffect(() => {
		if (props.isNavigatedFromPreviousStep) {
			state.name && setProjectName(state.name);
			state.clients.length > 0 && setCustomSelectedClients(state.clients.map((x) => x.id));
			props.setIsNavigatedFromPreviousStep(false);
		}
	}, [props.isNavigatedFromPreviousStep]);

	// Gets the data from API for Table
	// If page is loading after user navigated from next steps, no need to do API call as we have redux data for clients
	useEffect(() => {
		setshowClientError(false);
		if (!props.isNavigatedFromPreviousStep) {
			try {
				let url = `${env.getBaseURL(serviceURL)}Clients`;
				if (isRollForwardMode) {
					setClientsLoading(true);
					globalDispatch(getAllClients()).then(() => {
						setClientsLoading(false);
					});
				}
			} catch (err) {
				console.log(err);
			}
		} else {
			setClientsLoading(false);
		}
	}, []);

	useEffect(() => {
		if (clients?.length !== 0) {
			getRowData();
		}
	}, [clients]);

	// This effect gets called when Continue button is clicked.
	// responsible for data validation and updating step1 data in parent state.
	useEffect(() => {
		//Create Flow
		if (props.continueToNextStep) {
			if (isValidData()) {
				if (customSelectedClients?.length == 0) {
					setshowClientError(true);
				}
				const selectedData = rowData.filter((x) => _.includes(customSelectedClients, x.id));
				dispatch({
					type: projectActionTypes.UPDATE_STEP1_DATA,
					payload: {
						name: projectName,
						owners: [...users],
						clients: selectedData
					}
				});
				setSelectedClients(selectedData);

				if (isEditMode) {
					props.setActiveStepIndex(createProjectStepsIndex.createOrgChart);
					props.setContinueToNextStep(false);
				}
			} else {
				props.setContinueToNextStep(false);
			}
		}
	}, [props.continueToNextStep]);

	// This effect get called when Continue button is clicked
	// and in turn step data is updated in parent state.
	useEffect(() => {
		if (props.continueToNextStep && isValidData() && !isEditMode) {
			let projectApiUrl = `${env.getBaseURL(serviceURL)}Projects`;

			// First time project creation (New Project or RollForward). Both scenarios projectId will be 'null'.
			if (project.Id === '') {
				// project Id is blank first time save.
				setIsSaving(true); // On loading indicator
				if (isRollForwardMode) {
					globalDispatch(createRollForwardProject(projectApiUrl, {body: state})).then(() => {
						setIsSaving(false);
						props.setActiveStepIndex(createProjectStepsIndex.createOrgChart);
						props.setContinueToNextStep(false);
					});
				} else {
					globalDispatch(createProject(projectApiUrl, {body: state})).then(() => {
						setIsSaving(false); // off loading indicator
						props.setActiveStepIndex(createProjectStepsIndex.createOrgChart);
						props.setContinueToNextStep(false);
					});
				}

				// If project is created and user navigates back and changes clients. This executes only in Create flow. (Not for edit and Roll forward)
			} else if (!isRollForwardMode) {
				let removedEngagements = [];
				project.clients.forEach((savedClient) => {
					if (!_.find(state.clients, (newClient) => newClient == savedClient)) {
						// find engagements
						if (clientEngagements) {
							clientEngagements.forEach((x) => {
								if (x.clientEngagementCode == savedClient.clientCode) {
									removedEngagements.push(x.canvasEngagementId);
								}
							});
						}
					}
				});

				let savedProject = {
					...project,
					projectId: project.Id,
					id: project.Id,
					name: state.name,
					clients: state.clients,
					users: [],
					orgStructure: project.orgStructure.map((entity) => {
						return {
							...entity,
							accessGroups: [...entity.accessGroups],
							engagements:
								removedEngagements.length > 0
									? entity.engagements.filter((eng) => {
											return removedEngagements.includes(eng) == false;
									  })
									: [...entity.engagements]
						};
					})
				};

				let payload = {
					savedProject,
					stepUpdated: 1
				};

				setIsSaving(true); // loading indicator
				globalDispatch(updateProject(projectApiUrl + '/' + project.Id, payload)).then(() => {
					setIsSaving(false);
					props.setActiveStepIndex(createProjectStepsIndex.createOrgChart);
					props.setContinueToNextStep(false);
				});

				// If project is created and user navigates back and changes clients. This executes only for Rollforward flow.
			} else if (isRollForwardMode) {
				props.setActiveStepIndex(createProjectStepsIndex.createOrgChart);
				props.setContinueToNextStep(false);
				const payload = {clients: selectedClients};
				globalDispatch(clearClientEngagements(payload));
			}
		}
	}, [state.name, state.clients, state.status, state.owners]);

	useEffect(() => {
		if (customSelectedClients.length > 0 && showClientError) {
			setshowClientError(false);
		}
	}, [customSelectedClients]);

	//Creates array for the table data
	const getRowData = () => {
		let newData = [];
		let clientCodes = [];
		try {
			clients.map((c) => {
				let dataObject = {};
				dataObject.id = c.clientCode;
				dataObject.name = c.clientName;
				dataObject.source = c.sources.join(', ');
				dataObject.clientCode = c.clientCode;
				dataObject.entityIds = c.entityIds;

				const delegatedFromUsers = c.userIds.filter((userId) => userId !== userPreferences.userId);
				let delegatedUsersDetails = [];
				delegatedFromUsers.forEach((delegatedFromUser) => {
					const userDetails = userPreferences.delegatedFrom.find((user) => user.userId === delegatedFromUser);
					userDetails && delegatedUsersDetails.push({firstName: userDetails.firstName, lastName: userDetails.lastName});
				});
				delegatedUsersDetails =
					delegatedUsersDetails.length > 0
						? delegatedUsersDetails.sort(utilityfunctions.sortByMultipleKey(['firstName', 'lastName']))
						: [];
				delegatedUsersDetails.forEach(
					(user) => (user.fullName = `${user.firstName} ${user.lastName ? user.lastName : ''}`)
				);
				dataObject.delegatedFromUsers = delegatedUsersDetails;

				clientCodes.push(c.clientCode.toUpperCase());
				newData.push(dataObject);
			});
		} catch (err) {
			console.log(err);
		}

		// merge client from getClient and client from editing project if user already selected clients previously by using
		// delegate access from other users but now user does not have access to that clients because now he has not delegated same user.
		let updatedClients = newData;
		if (project.id) {
			updatedClients = getUpdateClients(newData, clientCodes);
		}
		const uniqueClients = updatedClients.filter(
			(obj, index) =>
				updatedClients.findIndex((item) => item.clientCode === obj.clientCode && item.name === obj.name) === index
		);
		updatedClients = utilityfunctions.sortListData(uniqueClients, 'name');
		setRowData(updatedClients);
		setClientSearchData(updatedClients);
	};

	const getUpdateClients = (clients, clientCodes) => {
		let oldProjectClient = project.clients.filter((client) => {
			return client.clientCode && !clientCodes.includes(client.clientCode.toUpperCase());
		});

		if (_.size(oldProjectClient) > 0) {
			const oldProjectClientItems = oldProjectClient.map((client) => { return client.id ? {...client} : {id: client.clientCode, ...client}});
			return [...clients, ...oldProjectClientItems];
		}

		return clients;
	};

	//Checks validity of input
	const isValidData = () => {
		let isValidData = true;

		if (!projectName || projectName.length > 100 || _.trim(projectName).length <= 0) {
			isValidData = false;
			setShowProjectNameValidation(true);
		} else {
			setShowProjectNameValidation(false);
		}

		if (
			users.length < userList.length ||
			users.filter((x) => users.filter((y) => y.userId == x.userId).length > 1).length > 1
		) {
			isValidData = false;
			setShowProjectOwnerValidation(true);
		} else {
			setShowProjectOwnerValidation(false);
		}

		if (!_.isEmpty(rowData)) {
			if (customSelectedClients.length == 0) {
				isValidData = false;
				setshowClientError(true);
			} else {
				setshowClientError(false);
			}
		} else {
			isValidData = false;
		}

		return isValidData;
	};

	const renderDelegateBadge = (item) => {
		let users = '';
		if (item.delegatedFromUsers && item.delegatedFromUsers.length !== 0) {
			item.delegatedFromUsers.forEach((user, index) => {
				users = index === 0 ? user.fullName : `${users}, ${user.fullName}`;
			});
		}
		return (
			<section className="delegate-col">
				{item.delegatedFromUsers && item.delegatedFromUsers.length !== 0 ? (
					<Tooltip
						contentClassName="delegate-tooltip"
						placement="left"
						allowHover={true}
						allowClick={false}
						children={`${labels.accessDelegatedBy} ${users}`}
						trigger={<MotifChip variant="monochrome-dark">{labels.delegateMember}</MotifChip>}
					/>
				) : (
					''
				)}
			</section>
		);
	};

	const tableColumns = [
		{
			label: labels.clientName,
			sortable: true,
			sort: 'asc',
			width: '50%',
			propName: 'name',
			sortBy: 'name'
		},
		{
			label: labels.source,
			sortable: true,
			width: '30%',
			propName: 'source'
		},
		{
			label: '',
			sortable: false,
			width: 'auto',
			propName: 'delegatedFromUsers',
			customCell: (item) => renderDelegateBadge(item)
		}
	];

	const onInputChange = (e) => {
		if (!e.target.value || e.target.value.length > 100 || _.trim(e.target.value).length <= 0) {
			setShowProjectNameValidation(true);
		} else {
			setShowProjectNameValidation(false);
		}
		setProjectName(e.target.value);
	};

	const handleSearchChange = (e) => {
		setSearchValue(e);
		updateClientList(e);
	};

	const handleClearClick = () => {
		setSearchValue('');
		updateClientList('');
	};

	const updateClientList = (searchStr) => {
		if (rowData && rowData.length > 0) {
			const filteredData = rowData.filter((x) => utilityfunctions.isTextIncluded(x.name, searchStr));
			setClientSearchData(filteredData);
		}
	};

	// Add user row
	const addOwnerbuttonClick = () => {
		let userId = `${userIdPrefix}${userList?.length}`;
		if (userList?.length > 0) {
			const lastUser = userList[userList.length - 1];
			let id = lastUser?.id;
			id = id.replace(userIdPrefix, '');
			id = parseInt(id);
			userId = `${userIdPrefix}${id + 1}`;
		}
		setUserList([...userList, {id: userId, isNewAdd: true}]);
	};

	// Delete user row
	const deleteProjectOwner = (item) => {
		setUsers(_.filter(users, (user) => user.id != item.id));
		setUserList(_.filter(userList, (user) => user.id != item.id));
		if (item.isNewAdd) {
			setShowProjectOwnerValidation(false);
		}
	};

	const renderAddOwnerBtn = () => {
		const props = {
			svg: IconoirPlusCircle,
			iconSize: 20,
			variant: 'text-alt',
			label: labels.addAnotherProjectOwner,
			onClick: () => addOwnerbuttonClick(),
			disabled: users && users.length < userList.length ? 'disabled' : ''
		};
		return <Button {...props} />;
	};

	const handleSelectRow = (selected) => {
		if (selected.length !== 0) {
			const clientCode = clientSearchData.map((x) => x.id).filter((id) => selected.has(id));
			setCustomSelectedClients([...clientCode]);
		} else {
			setCustomSelectedClients([]);
		}
	};

	const tableProps = {
		className: 'clients-table',
		columns: tableColumns,
		data: clientSearchData,
		selected: [...customSelectedClients],
		onSelect: handleSelectRow
	};

	const renderLinkTrigger = (label, href, target) => {
		const props = {
			label,
			href,
			target
		};

		return <TextLink {...props} />;
	};

	const renderInstructional = () => {
		// const props = {className: 'step1-instr'};

		const messageParts = labels.step1SubInstructionPart1.split('{link}');

		return (
			<StyledOutputTextWithLink>
				<div className="message">
					<OutputText body1 light>
						{utilityfunctions.createRichTextElement(messageParts[0])}
					</OutputText>
					{renderLinkTrigger(
						currentResource.createGRAProjectLabels.userGuideLinkText + '.',
						env.getURL('Get_Clients_Access_Url'),
						'_blank'
					)}
				</div>
			</StyledOutputTextWithLink>
		);
	};

	const renderDeleteBtn = (el) => {
		const propsBtn = {
			svg: IconoirTrash,
			variant: 'ghost',
			title: labels.delete,
			onClick: () => deleteProjectOwner(el)
		};

		return <Button {...propsBtn} />;
	};
	return (
		<LoadingWrapper isLoading={isSaving || clientsLoading}>
			<StyledStep1Section>
				<div className="header-content">
					<OutputText h4>{labels.step1InstructionHeader}</OutputText>
					{renderInstructional()}
				</div>

				<div className="project-name">
					<OutputText>{labels.projectName}</OutputText>
					<Input
						key={project.name}
						id={'projectName'}
						label={labels.projectName}
						maxLength="100"
						required={true}
						onChange={(e) => {
							onInputChange(e);
						}}
						value={projectName}
						errorMessage={showProjectNameValidation ? labels.required : null}
						className={'project-input-textbox'}
						inputClass="motif-input"
					/>
				</div>
				<div className="group-administrators">
					<OutputText>{labels.projectOwners}</OutputText>
					<div className="add-group-main-wrap">
						<ul className="add-group-name">
							{users &&
								users.length > 0 &&
								userList.length > 0 &&
								userList.map((el, index) => {
									return (
										<li key={el.id}>
											<AddProjectOwner
												users={users}
												setUsers={setUsers}
												userLookupType={UserLookupType.Internal}
												key={index == 0 ? el.id + userList.length : el.id}
												className="add-group-wrap"
												id={el.id}
												isNewAdd={el.isNewAdd}
												userError={showProjectOwnerValidation}
												setUserError={setShowProjectOwnerValidation}
												hideClearIcon={false}
											/>
											<div className="delete-icon">{!el.isLoggedInUser && renderDeleteBtn(el)}</div>
										</li>
									);
								})}
						</ul>
					</div>
					{renderAddOwnerBtn()}
				</div>
				{!clientsLoading && !_.isEmpty(rowData) ? (
					<section className="grid-container">
						<div className="header-wrap">
							<OutputText>{labels.clientsLabel}</OutputText>
							<Search
								value={searchValue}
								className="clients-search"
								placeholder={labels.searchClientList}
								onChange={handleSearchChange}
								onClear={handleClearClick}
								searchHoverText={labels.search}
							/>
						</div>
						<CustomTable {...tableProps} />

						{showClientError && (
							<StyledHelpBlock>
								<MotifIcon src={IconoirWarningCircle} size="20" />
								<OutputText body2>{labels.noRowSelected}</OutputText>
							</StyledHelpBlock>
						)}
					</section>
				) : (
					<section>
						<h5 className={`no-access-text' ${clientsLoading && 'hide'}`}>
							{labels.noRowsTemplateStringPart1}{' '}
							<a className="link" href={env.getURL('Get_Clients_Access_Url')}>
								<span>{labels.here}</span>
							</a>{' '}
							{labels.noRowsTemplateStringPart2}
						</h5>
					</section>
				)}
			</StyledStep1Section>
		</LoadingWrapper>
	);
};

export default CreateProjectStep1;

const StyledStep1Section = styled.section`
	margin-bottom: 1rem;
	.header-content {
		display: flex;
		flex-direction: column;
		gap: var(--spacing-large);
		padding-bottom: var(--spacing-x-large);
	}
	.project-name {
		display: flex;
		flex-direction: column;
		gap: var(--spacing-medium);
		padding-bottom: var(--spacing-x-large);
	}

	.group-administrators {
		padding-bottom: var(--spacing-x-large);
	}

	.motif-progress-loader-container {
		z-index: 2;
	}

	.input-invalid {
		.motif-input-component {
			input {
				border-bottom: solid 2px ${(props) => props.theme.color[`red600`]} !important;
				box-shadow: none;
			}
		}
	}

	.motif-input-component {
		.motif-input-clear-button {
			top: 1.6rem;
		}
	}

	.loader-back {
		z-index: 1;
	}

	.project-input-textbox {
		width: var(--px-590);
	}

	.grid-container {
		display: flex;
		flex-direction: column;
		gap: var(--spacing-x-large);
		.header-wrap {
			display: flex;
			flex-direction: column;
			gap: var(--spacing-medium);
			.motif-form-field {
				width: var(--px-400);
			}
		}
	}

	.group-administrators {
		display: flex;
		flex-direction: column;
		gap: var(--spacing-medium);
		.add-group-main-wrap {
			ul {
				padding-left: 0;
				margin: 0;
				li {
					display: flex;
					align-items: baseline;
					justify-content: space-between;
					width: 100%;
					margin: 0;
					.react-select__input {
						input {
							width: 92% !important;
						}
					}
				}
				.delete-icon {
					width: 10%;
					display: flex;
					justify-content: center;
					align-items: center;
					height: 5rem;
					svg {
						width: 2rem !important;
						height: 2rem !important;
						fill: ${(props) => props.theme.color[`black`]};
					}
				}
			}
		}

		.motif-button {
			align-self: start;
		}

		.add-group-wrap {
			margin: 0;
			.search-box-wrapper {
				margin-left: 0;
				padding-bottom: 0;
				max-height: none;
				width: 40%;
				.userfield-row {
					display: flex;
					flex-direction: column;
				}

				.enterdetail-description {
					bottom: 0;
					margin-top: 0.5rem;
					margin-left: 0;
				}
			}

			.group-input-textbox {
				width: 25%;
			}

			.user-selectbox {
				.clearall {
					margin-top: 0;
					&.disabled {
						visibility: hidden;
					}
				}
			}
		}
	}
`;

const StyledHelpBlock = styled.section`
	color: ${(props) => props.theme.color[`red600`]};
	margin-top: 0.5rem;
	font-size: 1.3rem;

	.motif-icon {
		color: ${(props) => props.theme.color[`red600`]};
	}
	svg {
		margin: 0 0.5rem 0 0;
		vertical-align: text-bottom;
	}
`;
